import React, { ReactNode, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { startOfDay, subDays } from 'date-fns';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';
import { reinterpretUTCAsLocalDate } from 'src/components/common/InsightsDateRangeControl/InsightsDateRangeControl.utils';
import {
  DATE_RANGE_KEY,
  INSIGHTS_LOCATIONS_KEY,
} from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/constants/businessInsights';

export interface InsightsFormFields {
  [DATE_RANGE_KEY]: {
    from: Date;
    to: Date;
  };
  [INSIGHTS_LOCATIONS_KEY]: {
    id: string;
    displayName: string;
  }[];
}

interface InsightsFormWrapperProps {
  children: ReactNode;
}

const DEFAULT_DATE_RANGE_DAYS = 90;

export const InsightsFormWrapper: React.FC<InsightsFormWrapperProps> = ({
  children,
}) => {
  const { dataLastUpdated } = useBusinessInsightsContext();

  const defaultValues = useMemo<InsightsFormFields>(() => {
    const today = startOfDay(new Date());
    const formattedDataLastUpdated = reinterpretUTCAsLocalDate(dataLastUpdated);

    const toDate = formattedDataLastUpdated
      ? startOfDay(formattedDataLastUpdated)
      : subDays(today, 1);

    return {
      [DATE_RANGE_KEY]: {
        from: subDays(today, DEFAULT_DATE_RANGE_DAYS),
        to: toDate,
      },
      [INSIGHTS_LOCATIONS_KEY]: [],
    };
  }, [dataLastUpdated]);

  const methods = useForm<InsightsFormFields>({
    mode: 'onChange',
    defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
